/****************************************************
 * Module Name:  packetIssueReceiveAssignMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import * as React from "react";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import PacketIssueMaster from '../manufactureMaster/packetIssueMaster'
import PacketReceiveMaster from '../manufactureMaster/packetReceiveMaster'
import PacketAssignMaster from '../manufactureMaster/packetAssignMaster'
import Constants from "../../utility/constants";
import { FaArrowAltCircleLeft, FaArrowRight } from "react-icons/fa";
import { GrMultiple } from "react-icons/gr";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ pt: 1 }}>
                    <Typography component={"span"}>{children}</Typography>
                </Box>
            )}
        </Box>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`,
        value: index,
    };
}

export default function PacketIssueReceiveAssignMaster() {
    const theme = useTheme();
    const [value, setValue] = React.useState(
        Constants.USER_PERMISSION.find(
            (iPermission) =>
                iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_OPERATION_PACKETISSUE
        ) !== undefined
            ? 0
            : Constants.USER_PERMISSION.find(
                (iPermission) =>
                    iPermission.permissionid ===
                    Constants.PERMISSIONS.MANUFACTURING_OPERATION_PACKETRECEIVE
            ) !== undefined
                ? 1 : Constants.USER_PERMISSION.find(
                    (iPermission) =>
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_PACKETASSIGN
                ) !== undefined ? 2
                    : 0
    );

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    return (
        // <Container maxWidth="xxl">
        <Box
            sx={{ bgcolor: "background.paper", width: "100%", padding: "10px" }}
        >
            <AppBar position="static" sx={{ bgcolor: "#03a9f4", height: 50 }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="secondary"
                    textColor="inherit"
                    variant="fullWidth"
                    aria-label="full width tabs example"
                    sx={{
                        "& .css-1vw5i9y-MuiButtonBase-root-MuiTab-root": {
                            color: "#212121",
                            fontWeight: Constants.defaultFontWeightBold,
                            textAlign: 'center'
                        },
                        "& .MuiTab-root": {
                            paddingBottom: 4
                        },
                        "& .Mui-selected": {
                            bgcolor: "#0277bd !important",
                            color: "#fafafa !important",
                            fontWeight: "bold !important",
                            paddingBottom: 4
                        }
                    }}
                    TabIndicatorProps={{ style: { background: "#0277bd" } }}
                >
                    {Constants.USER_PERMISSION.find(
                        (iPermission) =>
                            iPermission.permissionid ===
                            Constants.PERMISSIONS.MANUFACTURING_OPERATION_PACKETISSUE
                    ) !== undefined ? (
                        <Tab
                            icon={<GrMultiple size={'15px'} />}
                            iconPosition="start"
                            label="ISSUE"
                            {...a11yProps(0)}
                        />
                    ) : null}
                    {Constants.USER_PERMISSION.find(
                        (iPermission) =>
                            iPermission.permissionid ===
                            Constants.PERMISSIONS.MANUFACTURING_OPERATION_PACKETRECEIVE
                    ) !== undefined ? (
                        <Tab
                            icon={<FaArrowRight size={'15px'} />}
                            iconPosition="start"
                            label="RECEIVE"
                            {...a11yProps(1)}
                        />
                    ) : null}
                    {Constants.USER_PERMISSION.find(
                        (iPermission) =>
                            iPermission.permissionid ===
                            Constants.PERMISSIONS.MANUFACTURING_OPERATION_PACKETASSIGN
                    ) !== undefined ? (
                        <Tab
                            icon={<FaArrowAltCircleLeft size={'15px'} />}
                            iconPosition="start"
                            label="ASSIGN"
                            {...a11yProps(2)}
                        />
                    ) : null}
                </Tabs>
            </AppBar>
            <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={value}
                onChangeIndex={handleChangeIndex}
            >
                {Constants.USER_PERMISSION.find(
                    (iPermission) =>
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_PACKETISSUE
                ) !== undefined ? (
                    <TabPanel value={value} index={0}>
                        <PacketIssueMaster />
                    </TabPanel>
                ) : null}
                {Constants.USER_PERMISSION.find(
                    (iPermission) =>
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_PACKETRECEIVE
                ) !== undefined ? (
                    <TabPanel value={value} index={1}>
                        <PacketReceiveMaster />
                    </TabPanel>
                ) : null}
                {Constants.USER_PERMISSION.find(
                    (iPermission) =>
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_PACKETASSIGN
                ) !== undefined ? (
                    <TabPanel value={value} index={2}>
                        <PacketAssignMaster />
                    </TabPanel>
                ) : null}
            </SwipeableViews>
        </Box>
        // </Container>
    );
}
